import React from 'react';
import { Card, CardActions, CardContent, CardHeader } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Appointment } from '../../guardianApp/components/Appointment/appointment.smart';
import { GPClearance } from '../../guardianApp/components/gpClearance/gpClearance.smart';

interface NextStepsProps {
  player?: string;
}

export function NextSteps({ player }: NextStepsProps) {
  const { t } = useTranslation();
  return (
    <Card sx={{ borderRadius: 4 }}>
      <CardHeader
        title={t(
          'incident.INCIDENT_NEXT_STEPS_HEADING_MEDICAL_ADVICE',
        ).toString()}
      />
      <CardContent>
        {t('incident.INCIDENT_NEXT_STEPS_CONTENT_MEDICAL_ADVICE', {
          player,
        })
          .toString()
          .split('\n')}
      </CardContent>
      <CardActions>
        <>
          <Appointment />
          <GPClearance />
        </>
      </CardActions>
    </Card>
  );
}
